import kformUtils from "../../utils/kform-utils";

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.fbdata = [];

	if ($scope.options && $scope.options.building) {
		return;
	}

	$scope.changeValue = () => {
		if ($scope.component.event && typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
}
